import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, map, Observable } from 'rxjs';
import { IDescription } from 'src/app/shared/models/description.model';
import { IBasePerson } from 'src/app/shared/people/models/person';
import { environment } from '../../../../environments/environment';
import { IHello } from '../hello.model';

@Injectable({
  providedIn: 'root'
})
export class ImpersonateRepository {
  public readonly impersonateUrl: string = `${environment.apiUrl}/switch-user?username=`;

  constructor(
    private http: HttpClient,
  ) { }

  public whoAmI(): Observable<IDescription> {
    return this.http.get<IDescription>(`${environment.apiUrl}/who-am-i`);
  }

  public getUsernameFromLuid(luid: string): Observable<IDescription> {
    return this.http.get<IDescription>(`${environment.apiUrl}/username?luid=${luid}`);
  }

  public getPerson(): Observable<IHello> {
    return forkJoin([
      this.http.get<IHello>(`${environment.apiUrl}/hello-user`),
      this.http.get<Array<string>>(`${environment.apiUrl}/roles.json`)],
    ).pipe(
      map(([hello, roles]: [IHello, Array<string>]) => {
        return Object.assign({}, hello, { roles });}),
    );
  }

  public impersonateUser(username: string): Observable<IHello> {
    return this.http.post<IHello>(`${this.impersonateUrl}${username}`, null);
  }

  public stopImpersonating(): Observable<IBasePerson> {
    return this.http.post<IBasePerson>(`${environment.apiUrl}/exit-user`, null);
  }
}